// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
  width: 100%;
  height: 100%;
}

.venues {
  padding-left: 5px;
  padding-right: 5px;
}
.venues .title {
  display: none;
  font-size: 21px;
  line-height: 21px;
  margin: 0 0 24px;
}
@media (min-width: 991px) {
  .venues .title {
    display: block;
  }
}
@media (min-width: 991px) {
  .venues {
    width: 100%;
    padding: 24px;
  }
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

#search-container {
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  padding: 4px;
}

.select-venue {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  width: 100%;
}
.select-venue .button {
  border-radius: 4px;
  background: #f4f4f4;
  color: #9f9f9f;
  text-align: center;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}
.select-venue .button:first-child {
  margin-right: 3px;
}
.select-venue .button:last-child {
  margin-left: 3px;
}
.select-venue .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-subway-yellow);
  color: var(--ion-color-subway-green-dark);
}
.select-venue .button.active:hover {
  transition: 0.3s linear;
  background: var(--ion-color-subway-yellow-dark);
}

.no-place {
  padding: 16px 9px;
  font-family: Subway-bold, sans-serif;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 12px;
  line-height: 131.5%;
}

.suggested-place {
  background: #f4f4f4;
  place-items: center;
  padding: 15px 20px;
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: #878787 !important;
}
.suggested-place .actual-position-title {
  color: var(--ion-color-subway-green-dark);
  font-size: 14px;
}
.suggested-place .actual-position {
  font-size: 13px;
}

.delivery-venues-container {
  max-height: 40vh;
  overflow: auto;
  padding: 4px;
}
@media (min-width: 991px) {
  .delivery-venues-container {
    max-height: unset;
    margin: 0;
    overflow: auto;
  }
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

ion-content > ion-col {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.align-bottom {
  position: absolute;
  max-height: 40vh;
  bottom: 0;
}
@media (min-width: 991px) {
  .align-bottom {
    position: relative;
    bottom: unset;
    max-height: unset;
    height: 100%;
    overflow: auto;
  }
}

.center {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

ion-header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
}
ion-header .toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
ion-header .toolbar ion-icon {
  width: 145px;
  height: 50px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-toggle {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 5px;
}

.map-toggle-container {
  height: 48px;
  margin: 4px 0;
  background: white;
}

.mode-icon {
  padding: 10px;
  height: 40px;
  width: 40px;
}

.mode-icon {
  background: #f8f8f8;
  color: var(--ion-color-black);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  color: #f8f8f8;
  transition: 0.3s linear;
}

ion-header {
  background: var(--ion-color-secondary) center bottom/105% no-repeat !important;
}
ion-header .toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 75px;
  padding: 0px 20px;
}
ion-header .toolbar ion-img {
  width: 180px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}

.row-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 20px;
}
.row-block .logo-icon {
  height: 51px;
  width: 110px;
}
@media (min-width: 991px) {
  .row-block .logo-icon {
    height: 57px;
    width: 157px;
    padding: 10px;
  }
}
.row-block .home-click {
  cursor: pointer;
}
.row-block .width-20 {
  width: 25%;
  text-align: left;
}
.row-block .width-20:last-child {
  text-align: right;
}

#map {
  width: 100%;
  height: 100%;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

#search-container {
  top: 4px;
  left: 4px;
  right: 4px;
  position: absolute;
  padding: 4px;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

.mode-icon {
  padding: 6px;
  height: 23px;
  width: 23px;
  border-radius: 1px;
}

.mode-icon {
  background: white;
  color: var(--ion-color-black);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  color: white;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

ion-header {
  background: var(--ion-color-secondary) center bottom/105% no-repeat !important;
}
ion-header .toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 75px;
  padding: 0px 20px;
}
ion-header .toolbar ion-img {
  width: 180px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/venue-link-test-url/venue-link-test-url.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,iBAAA;EACA,kBAAA;AADF;AAGE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AADJ;ACbE;EDUA;IAMI,cAAA;EACJ;AACF;AClBE;EDMF;IAeI,WAAA;IACA,aAAA;EACF;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,iBAAA;AACJ;AACI;EACE,iBAAA;AACN;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,uBAAA;EACA,0CAAA;EACA,yCAAA;AADN;AAGM;EACE,uBAAA;EACA,+CAAA;AADR;;AAOA;EACE,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;AAJF;AAME;EACE,kBAAA;EACA,wBAAA;AAJJ;AAOE;EACE,yCAAA;EACA,eAAA;AALJ;AAQE;EACE,eAAA;AANJ;;AAUA;EACE,gBAAA;EACA,cAAA;EACA,YAAA;AAPF;AC7GE;EDiHF;IAMI,iBAAA;IACA,SAAA;IACA,cAAA;EANF;AACF;;AASA;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AANF;AAQE;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AARJ;;AAYA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;AATF;ACrJE;ED2JF;IAKI,kBAAA;IACA,aAAA;IACA,iBAAA;IACA,YAAA;IACA,cAAA;EAPF;AACF;;AAUA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAPF;;AASA;EAEE,4BAAA;EACA,sBAAA;EACA,2BAAA;AAPF;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AANJ;AAOI;EACE,YAAA;EACA,YAAA;AALN;AAOI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AALN;;AAUA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AAPF;;AASA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,YAAA;EACA,WAAA;AANF;;AASA;EACE,mBAAA;EACA,6BAAA;EACA,uBAAA;AANF;;AASA;EACE,oCAAA;EACA,cAAA;EACA,uBAAA;AANF;;AASA;EACE,8EAAA;AANF;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AAOI;EACE,YAAA;AALN;AAOI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AALN;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAPF;AAQE;EACE,YAAA;EACA,YAAA;AANJ;ACvPE;ED2PA;IAII,YAAA;IACA,YAAA;IACA,aAAA;EAJJ;AACF;AAME;EACE,eAAA;AAJJ;AAOE;EACE,UAAA;EACA,gBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;;AAQA;EACE,WAAA;EACA,YAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AALF;;AAQA;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AALF;AAOE;EACE,WAAA;AALJ;;AASA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AANF;;AASA;EACE,oBAAA;AANF;;AAWA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AARF;;AAWA;EACE,iBAAA;EACA,6BAAA;EACA,uBAAA;AARF;;AAWA;EACE,oCAAA;EACA,YAAA;EACA,uBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EAKE,cAAA;EACA,YAAA;AAZF;AAOE;EACE,gBAAA;AALJ;AAWE;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAVF;;AAaA;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAVF;AAYE;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAVJ;AAaE;EACE,eAAA;AAXJ;AAcE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAZJ;;AAgBA;EACE,8EAAA;AAbF;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAbJ;AAcI;EACE,YAAA;AAZN;AAcI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAZN","sourcesContent":["@import \"../../../theme/mixins\";\n\n#map {\n  width: 100%;\n  height: 100%;\n}\n\n.venues {\n  padding-left: 5px;\n  padding-right: 5px;\n\n  .title {\n    display: none;\n    font-size: 21px;\n    line-height: 21px;\n    margin: 0 0 24px;\n    @include desktop {\n      display: block;\n    }\n  }\n\n  @include desktop {\n    width: 100%;\n    padding: 24px;\n  }\n}\n\n.search-bar {\n  border-radius: 4px;\n  line-height: 1.6;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n}\n\n#search-container {\n  top: 0;\n  left: 0;\n  right: 0;\n  position: absolute;\n  padding: 4px;\n}\n\n.select-venue {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 16px;\n  width: 100%;\n\n  .button {\n    border-radius: 4px;\n    background: #f4f4f4;\n    color: #9f9f9f;\n    text-align: center;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n    font-weight: bold;\n\n    &:first-child {\n      margin-right: 3px;\n    }\n\n    &:last-child {\n      margin-left: 3px;\n    }\n\n    &.active {\n      transition: 0.3s linear;\n      background: var(--ion-color-subway-yellow);\n      color: var(--ion-color-subway-green-dark);\n\n      &:hover {\n        transition: 0.3s linear;\n        background: var(--ion-color-subway-yellow-dark);\n      }\n    }\n  }\n}\n\n.no-place {\n  padding: 16px 9px;\n  font-family: Subway-bold, sans-serif;\n  background: #ffffff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 131.5%;\n}\n\n.suggested-place {\n  background: #f4f4f4;\n  place-items: center;\n  padding: 15px 20px;\n\n  .navigate-icon {\n    margin-right: 15px;\n    fill: #878787 !important;\n  }\n\n  .actual-position-title {\n    color: var(--ion-color-subway-green-dark);\n    font-size: 14px;\n  }\n\n  .actual-position {\n    font-size: 13px;\n  }\n}\n\n.delivery-venues-container {\n  max-height: 40vh;\n  overflow: auto;\n  padding: 4px;\n\n  @include desktop {\n    max-height: unset;\n    margin: 0;\n    overflow: auto;\n  }\n}\n\n.hint {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 14px;\n  background: white;\n\n  p {\n    font-size: 12px;\n    color: black;\n    margin: 0;\n    padding: 0 8px;\n  }\n\n  span {\n    font-size: 14px;\n  }\n\n  ion-icon {\n    height: 44px;\n    width: 44px;\n    place-self: center;\n  }\n}\n\nion-content > ion-col {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.align-bottom {\n  position: absolute;\n  max-height: 40vh;\n  bottom: 0;\n  @include desktop {\n    position: relative;\n    bottom: unset;\n    max-height: unset;\n    height: 100%;\n    overflow: auto;\n  }\n}\n\n.center {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\nion-header {\n  // background: #f1f1f1 url(../../../assets/tabilo/menu_toolbar_background.svg) center bottom/105% no-repeat !important;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: bottom;\n  .toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    ion-icon {\n      width: 145px;\n      height: 50px;\n    }\n    .right-block {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n\n.map-toggle {\n  display: flex;\n  justify-content: space-between !important;\n  align-items: center;\n  padding: 5px;\n}\n.map-toggle-container {\n  height: 48px;\n  margin: 4px 0;\n  background: white;\n}\n\n.mode-icon {\n  padding: 10px;\n  height: 40px;\n  width: 40px;\n}\n\n.mode-icon {\n  background: #f8f8f8;\n  color: var(--ion-color-black);\n  transition: 0.3s linear;\n}\n\n.mode-icon.selected {\n  background: var(--ion-color-primary);\n  color: #f8f8f8;\n  transition: 0.3s linear;\n}\n\nion-header {\n  background:var(--ion-color-secondary) center bottom/105% no-repeat !important;\n\n  .toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 75px;\n    padding: 0px 20px;\n    ion-img {\n      width: 180px;\n    }\n    .right-block {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n@import \"../../../theme/mixins\";\n.row-block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 20px;\n  .logo-icon {\n    height: 51px;\n    width:110px;\n    @include desktop {\n      height: 57px;\n      width: 157px;\n      padding: 10px;\n    }\n  }\n  .home-click {\n    cursor: pointer;\n  }\n\n  .width-20 {\n    width: 25%;\n    text-align: left;\n  }\n  .width-20:last-child {\n    text-align: right;\n  }\n}\n#map {\n  width: 100%;\n  height: 100%;\n}\n\n.search-bar {\n  border-radius: 4px;\n  line-height: 1.6;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n}\n\n#search-container {\n  top: 4px;\n  left: 4px;\n  right: 4px;\n  position: absolute;\n  padding: 4px;\n\n  app-venue-suggestion {\n    width: 100%;\n  }\n}\n\n.slides-container {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n}\n\n.swiper-slide {\n  align-self: flex-end;\n}\n\n\n\n.mode-icon {\n  padding: 6px;\n  height: 23px;\n  width: 23px;\n  border-radius: 1px;\n}\n\n.mode-icon {\n  background: white;\n  color: var(--ion-color-black);\n  transition: 0.3s linear;\n}\n\n.mode-icon.selected {\n  background: var(--ion-color-primary);\n  color: white;\n  transition: 0.3s linear;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.sidebar {\n  app-venue-suggestion {\n    margin: 5px auto;\n  }\n\n  overflow: auto;\n  height: 100%;\n\n  .title {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.loading-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 10;\n  background: black;\n  opacity: 0.5;\n}\n\n.hint {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 14px;\n  background: white;\n\n  p {\n    font-size: 12px;\n    color: black;\n    margin: 0;\n    padding: 0 8px;\n  }\n\n  span {\n    font-size: 14px;\n  }\n\n  ion-icon {\n    height: 44px;\n    width: 44px;\n    place-self: center;\n  }\n}\n\nion-header {\n  background:var(--ion-color-secondary) center bottom/105% no-repeat !important;\n\n  .toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 75px;\n    padding: 0px 20px;\n    ion-img {\n      width: 180px;\n    }\n    .right-block {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
